import { ResearchResultRootGroup, ResearchResults_ResponseData } from '../api/chatApi/chatApi';
import { groupBy, filter, sort } from 'ramda';
import { useMemo } from 'react';
import { compose } from 'redux';
import useResearchHistory from './useResearchHistory';

const useResearchHistoryByTitle = () => {
  const researchHistory = useResearchHistory();
  // researchHistory.forEach((el: any) => {
  //   if (el.text.indexOf('}') === -1) {
  //     el.type = 'String';
  //   }
  // });

  const researchesResultsByTitle: Array<[string, Array<ResearchResults_ResponseData>]> = useMemo(() => {
    return compose<Array<[string, Array<ResearchResults_ResponseData>]>>(
      sort(([title1], [title2]) => title1.localeCompare(title2)),
      Object.entries,
      groupBy<ResearchResults_ResponseData>(a => a.title),
      sort<ResearchResults_ResponseData>((a, b) => a.type.localeCompare(b.type)),
      filter<ResearchResults_ResponseData>(it => !!it.title && !!it.type)
    )(researchHistory);
  }, [researchHistory]);

  return researchesResultsByTitle;
};

export default useResearchHistoryByTitle;
